import useWalletConnector from '@/src/components/AppComponents/WalletConnector/useWalletConnector';
import { Button } from '@/src/components/Commons/Button';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { DelegationEntity, FundWithDetailsEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore } from '@/src/store';
import { showTokenGov_Amount_Rounded } from '@/src/store/global/tokensStoreModelHelpers';

interface BtnConfirmationProps {
    isDeposit: boolean;
    fund: FundWithDetailsEntity;
    isLoadingDelegation: boolean;
    isLoadedDelegation: boolean;
    isTokensStoreReady: boolean;
    isAddingTokens: boolean;
    delegation: DelegationEntity | undefined;
    amount_TokenGov: bigint;
    isValidTx: boolean;
    isProcessingTx: boolean;
    setShowProcessingTx: (show: boolean) => void;
    setShowUserConfirmation: (show: boolean) => void;
}

export default function BtnConfirmation(props: BtnConfirmationProps) {
    //--------------------------------------
    const { walletStore } = useWalletConnector();
    //--------------------------------------
    const tokensStore = useTokensStore();
    //--------------------------------------
    const {
        isDeposit,
        fund,
        isLoadingDelegation,
        isLoadedDelegation,
        isTokensStoreReady,
        isAddingTokens,
        delegation,
        amount_TokenGov,
        isValidTx,
        isProcessingTx,
        setShowProcessingTx,
        setShowUserConfirmation,
    } = props;
    //--------------------------------------
    const isWalletConnected = walletStore.isConnected;
    const isLoading = !isTokensStoreReady || isAddingTokens || walletStore.isWalletDataLoading || isLoadingDelegation || !isLoadedDelegation;
    const isDelegationRequired = delegation === undefined && !isDeposit;
    const canShowActionButtons = isLoadedDelegation && (!isDelegationRequired || isDeposit);
    //--------------------------------------
    return (
        <>
            {isWalletConnected ? (
                isLoading ? (
                    <Button mode="filled" disabled={true} arrow={false}>
                        <LoaderButton classNameStyle={'black'} />
                        LOADING...
                    </Button>
                ) : canShowActionButtons ? (
                    <Button mode="filled" disabled={!isValidTx} arrow={false} onClick={() => (isProcessingTx ? setShowProcessingTx(true) : setShowUserConfirmation(true))}>
                        {isProcessingTx ? (
                            <>
                                <LoaderButton classNameStyle={'black'} />
                                PROCESSING...
                            </>
                        ) : isDeposit ? (
                            `STAKE ${showTokenGov_Amount_Rounded(tokensStore, amount_TokenGov)} IN ${fund.name}`
                        ) : (
                            `UNSTAKE ${showTokenGov_Amount_Rounded(tokensStore, amount_TokenGov)} FROM ${fund.name}`
                        )}
                    </Button>
                ) : (
                    <Button mode="filled" disabled={true} arrow={false}>
                        A DELEGATION IS REQUIRED
                    </Button>
                )
            ) : (
                <Button mode="filled" disabled={true} arrow={false}>
                    CONNECT WALLET TO {isDeposit ? `STAKE` : `UNSTAKE`}
                </Button>
            )}
        </>
    );
}
